import React from 'react';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/map';
import 'echarts/map/js/china.js';
import geoCoordMap from './chinaCity.js';
import http from '../../../../axios/http';

const colorWhite = {
    backgroundColor: '#2414f4', //'#1b1b1b'
    mapColor: '#1b1b1b',
    fontColor: '#1b1b1b',
    pointColor: '#ffffff',
    // lineColor: '#45f845' //
    lineColor: '#60acfc', //
    linePointColor: '#91c5fc'
}

// const colorBlack = {
//     backgroundColor: '#1b1b1b', //'#1b1b1b'
//     mapColor: '#1b1b1b',
//     fontColor: '#ffffff',
//     pointColor: '#ffffff',
//     lineColor: '#45f845', //
//     linePointColor: '#ffffff'
// }

const lineColors = ["#22f6f6", "#ffa022", "#46bee9", "#ff7e7e", "#ff7e7e"];

class ChartMapLine extends React.Component {
    state = {
        myChart: {},
        isFullScreen: false,
        ...colorWhite,
        lineData:[]
    }
    getData=()=>{
        http.post({
            url: '/applySummary/findDestination',
            data: { year: '2019' },
            success: (res) => {
                let goData = [];
                let XMData=[];
                let HFData = [];
                if(res != null){
                    for (let i = 0; i < res.length; i++) {
                        let city =this.getCity(res[i].destination);
                        city = city.replace("新疆", "");
                        city = city.replace("维吾尔", "");
                        city = city.replace("西藏", "");
                        city = city.replace("广西", "");
                        city = city.replace("宁夏", "");
                        city = city.replace("内蒙古", "");
                        goData.push(city);
                        XMData.push([{name:'厦门'}])
                    }
                    for(let j=0;j<res.length;j++){
                        let item =[{name:'厦门'},{name:goData[j],value:res[j].countNum}]
                        HFData.push(item);
                    }
                }
                this.setState({
                    lineData:HFData
                })
                let myChart = echarts.init(document.getElementById('china_map'));
                // 绘制图表
                myChart.setOption(this.getOption());
                this.setState({ myChart: myChart });
            }
        });
    }
    componentDidMount() {
        this.getData();
        // 初始化
      
        window.addEventListener('resize', this.handleResize, false);
    }
    getCity = (str) => {
        var reg = /.+?(省|市|自治区)/g;
        var province = ["河北","山西","辽宁","吉林","黑龙江","江苏","浙江","安徽","福建","江西","山东","河南","湖北","湖南","广东","海南","四川","贵州","云南 ","陕西 ","甘肃","青海","台湾","西藏","广西壮族","内蒙古","宁夏回族","新疆维吾尔","新疆","广西","宁夏","香港特别行政区","澳门特别行政区","香港","澳门"]
        var provinces = ["北京","上海","天津","重庆"]
       if(str.match(reg) == null) {
             for(var i = 0;i<provinces.length;i++){
               if(str.indexOf(provinces[i]) !== '-1'){
                    return provinces[i]
                }
             }
            for(var j = 0;j<province.length;j++){
                if(str.indexOf(province[j]) !== '-1'){
                    return str.slice(province[j].length,str.length)
                }
            }
       }else{
        var egg = str.match(reg).length<2?str.match(reg)[0]:str.match(reg)[1];
        return egg.slice(0,egg.length-1)
       }
    }

    getOption = () => {
        let HFData = this.state.lineData;
        // var HFData = [
        //     // 数据中name的城名称必须与geoCoordMap中城名称一致, 不然关联不上，合肥到各地区的线路
        //     [{ name: '厦门' }, { name: '泉州', value: 99 }],
        //     [{ name: '厦门' }, { name: '福州', value: 66 }],
        //     [{ name: '厦门' }, { name: '莆田', value: 16 }],
        //     [{ name: '厦门' }, { name: '上海', value: 6 }],
        //     [{ name: '厦门' }, { name: '北京', value: 3 }],
        //     [{ name: '厦门' }, { name: '天津', value: 1 }],
        //     [{ name: '厦门' }, { name: '大连', value: 2 }],
        //     [{ name: '厦门' }, { name: '南宁', value: 4 }],
        //     [{ name: '厦门' }, { name: '成都', value: 5 }],
        //     [{ name: '厦门' }, { name: '乌鲁木齐', value: 1 }],
        //     [{ name: '厦门' }, { name: '太原', value: 2 }],
        //     [{ name: '厦门' }, { name: '西安', value: 3 }],
        //     [{ name: '厦门' }, { name: '哈尔滨', value: 2 }],
        //     [{ name: '厦门' }, { name: '杭州', value: 10 }],
        //     [{ name: '厦门' }, { name: '温州', value: 5 }],
        //     [{ name: '厦门' }, { name: '赣州', value: 23 }],
        //     [{ name: '厦门' }, { name: '南昌', value: 21 }],
        //     [{ name: '厦门' }, { name: '广州', value: 34 }],
        //     [{ name: '厦门' }, { name: '深圳', value: 12 }],
        //     [{ name: '厦门' }, { name: '揭阳', value: 14 }],
        // ];
        let lineData = [];
        let pointData = [];
        HFData.forEach((item) => {
            var fromCoord = geoCoordMap[item[0].name];
            var toCoord = geoCoordMap[item[1].name];
            if (fromCoord && toCoord) {
                let value = item[1].value;
                let color = lineColors[0];
                if(value != null){
                    let i = Math.floor(value / 10);
                    if(i > lineColors.length){
                        i = lineColors.length -1;
                    }
                    color = lineColors[i];
                }
                lineData.push([{
                    name: item[0].name,
                    coord: fromCoord
                }, {
                    coord: toCoord,
                    name: item[1].name,
                    value: item[1].value,
                    lineStyle: {
                        color: color
                    }
                }]);
            }
            for (let i = 0; i < 2; i++) {
                if (pointData.indexOf(item[i].name) < 0) {
                    pointData.push(item[i].name);
                }
            }
        });


        // let date = new Date();
         var planePath = 'path://M716.817806 396.900565l-0.00307 0.00921-28.591176-7.658423v-146.44535c0-97.488335-78.571497-177.515996-177.514972-177.515997-98.942453 0-176.060855 80.027661-176.060855 177.515997V389.258515l-27.461445 7.357571-0.00307-0.009209c-17.410532 4.672416-29.502941 15.97381-27.021424 25.25315l31.460526-8.429997v0.010234l23.026436-6.16849v391.362432c0 88.757486 71.296813 160.055322 160.055323 160.055322h33.464159c88.75851 0 160.055322-71.298859 160.055322-160.055322v-391.373689l24.152073 6.472412 0.002047-0.010233 31.461549 8.429996c2.481518-9.279341-9.616008-20.579711-27.021423-25.252127zM451.05086 104.576777c1.455141-2.90926 7.274684-13.096273 27.64564-14.549368 20.370956-1.455141 49.470715-1.455141 61.111846 0 11.640108 1.453095 32.011064 8.729825 33.466206 13.094227 1.455141 4.365424-1.455141 7.27673-11.640108 7.27673-11.641131-1.455141-34.919301-2.910283-52.382021-2.910283-17.45965 0-36.375465 1.455141-48.015574 1.455141-11.641131-0.001023-11.641131-2.911306-10.185989-4.366447z m-11.640108 2.910283l-30.555924 212.437343c24.736381-8.731872 52.382021-11.640108 85.848227-11.640108 48.015573 0 87.301322 4.364401 117.857245 13.096273L580.549236 107.48706h2.910282l33.466206 215.346603c18.914792 5.821589 33.466206 13.096273 43.652196 23.281239 1.455141 1.455141 1.455141 2.910283 0 4.365424-1.455141 1.455141-2.910283 1.455141-4.366447 0-23.281239-21.826098-81.482803-36.377512-161.509441-36.377512-55.292304 0-98.943476 11.641131-129.500423 36.377512-1.455141 1.455141-2.910283 0-4.365424 0-1.453095-1.455141 0-2.910283 0-4.365424 13.096273-10.184967 27.646664-17.45965 43.652196-23.281239l32.011064-215.346603h2.911307z m-64.022129 286.645462c-4.364401-8.731872-4.364401-16.006556 0-23.281239 26.191522-21.826098 65.47727-33.466206 117.859291-33.466206 77.116355 0 120.768551 11.640108 135.319965 20.370956 16.004509 8.729825 23.281239 16.004509 16.004509 37.830607-7.274684 21.826098-18.915815 48.01762-21.826098 56.747445-2.908236 8.729825-5.819542 21.826098-24.734334 14.550391-20.370956-5.820566-46.562479-14.550391-81.481779-14.550391-34.921347 0-77.118402 5.819542-82.936921 10.184967-7.27673 1.455141-27.647687 10.18599-34.922371-5.819542-7.27673-16.007579-17.461697-50.928926-23.282262-62.566988z m23.280216 113.492844v84.393085l-39.285749 18.915816V404.317489l32.011065 59.656704c4.364401 14.548344 7.274684 29.099758 7.274684 43.651173z m224.076428 0c0-14.551414 2.910283-29.102828 7.27673-43.651173l32.011065-59.656704v206.616778l-39.287795-18.915816v-84.393085zM360.837208 162.779364c7.27673-20.370956 18.916838-50.92688 64.022129-53.837163-33.465183 33.466206-30.555923 29.100782-42.197054 48.015574-7.274684 11.640108-11.639085 27.646664-16.004509 46.562478-8.729825-13.095249-11.640108-27.646664-5.820566-40.740889z m-1.453094 462.703247l40.740889-18.914792v36.377512c0 13.094226-7.27673 29.100782-20.370956 46.560432l-20.370957 32.011065v-96.034217z m282.279014 203.707518c-7.27673 5.819542-16.006556 10.18599-26.192545 13.096273l-30.555923 98.942453c0 1.455141-1.455141 1.455141-2.910283 1.455141v-2.910283l30.555923-96.031146c-30.555923 11.639085-65.476247 17.45965-104.764042 17.45965-37.830607 1.455141-69.841671-4.365424-98.942453-16.006556l30.555923 96.033194c0 1.455141 0 1.455141-1.455141 2.910283-1.455141 0-1.455141 0-2.910283-1.455142l-29.100782-98.942453c-10.184967-4.365424-17.45965-8.731872-26.189475-14.551414-1.455141 0-1.455141-1.455141 0-2.910283s2.908236-1.455141 2.908236-1.455141c32.011064 21.826098 74.208119 32.011064 125.133975 32.011064 50.927903 0 94.578052-10.184967 132.410706-32.011064 1.455141 0 2.908236 0 2.908236 1.455141 0.001023 1.455141 0.001023 2.910283-1.452072 2.910283z m-16.006555-14.550391c-21.826098 13.096273-43.652196 29.101805-119.312386 26.191522-75.66326-1.455141-138.230248-29.100782-132.410706-58.202586 4.365424-18.915815 11.640108-48.015573 20.370957-85.846181 4.365424-13.096273 13.096273-18.916838 24.73638-18.916838h183.335539c14.551414 4.365424 23.281239 10.18599 24.736381 18.916838 2.910283 13.094226 18.915815 56.745399 18.915815 75.661214-0.002047 18.915815 2.90926 30.5549-20.37198 42.196031z m37.83163-93.12291l-20.37198-33.466206c-13.094226-17.460674-20.370956-33.465183-20.370956-46.560432v-36.377512l40.742936 18.916838v97.487312z m-7.27673-517.996575c-2.908236-18.915815-8.729825-34.922371-16.004509-48.01762-11.641131-18.915815-8.730848-14.549368-42.197055-48.015573 45.105291 2.910283 56.745399 33.467229 64.022129 53.837162 5.820566 14.549368 4.365424 29.100782-5.820565 42.196031z';
       
         // 指定相关的配置项和数据
        let option = {
            title: {
                text: '近30天交易流向',
                left: 'center',
                top: '30%',
                textStyle: {
                    color:'#fff',
                    // fontSize: '18px'
                }
            },
            backgroundColor: '',
            tooltip: {
                trigger: 'item',
                formatter: function (params) {
                    let param = params["data"];
                    return param["fromName"] + "->" + param["toName"] + "：" + param["value"] + "辆";
                    // return param["fromName"] + "->" + param["toName"] 
                }
            },
            geo: {
                map: 'china',
                roam: true, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
                aspectScale: 0.75,
                zoom: 1,
                top: 150,
                label: {
                    normal: {
                        show: false
                    },
                    emphasis: { // 对应的鼠标悬浮效果
                        show: false
                    }
                },
                itemStyle: {
                    normal: {
                        areaColor:new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#021b36'},
                                {offset: 0.5, color: '#021b36'},
                                {offset: 1, color: '#021b36'}
                            ]
                        ),
                        borderColor: '#1c21ff',
                        borderWidth: 2,
                        color: '#fff'
                    },
                    emphasis: { // 对应的鼠标悬浮效果
                        areaColor: this.state.backgroundColor,
                        borderColor: '#fff',
                    }
                }
            },
            series: [{
                name: '交易流向',
                type: 'lines',
                zlevel: 1,
                // effect: {
                //     show: true,
                //     period: 6,
                //     trailLength: 0.7,
                //     symbol: planePath,
                //     color: this.state.linePointColor,
                //     symbolSize: 
                // },
                effect: {
                    show: true,
                    period: 6,
                    trailLength: 0,
                    symbol: planePath,
                    symbolSize: 15,
                    //color:'#3a7bff'
                },
                lineStyle: {
                    normal: {
                        // color: this.state.lineColor,
                        //color: '#fff',
                        width: 1,    // 对应流动线宽度
                        curveness: 0.2
                    },
                    emphasis: { // 对应的鼠标悬浮效果
                        //color: '#3fd6ff',
                        width: 4,
                        curveness: 0.2
                    }
                },
                data: lineData
            }, {
                // 目的地信息
                type: 'effectScatter',
                tooltip: {
                    show: false
                },
                coordinateSystem: 'geo',
                zlevel: 2,
                rippleEffect: {
                    // period: 2.5, //波纹秒数,
                    brushType: 'stroke', //stroke(涟漪)和fill(扩散)，两种效果
                    scale: 15 //波纹范围

                },
                label: {
                    normal: {
                        show: false,  //城市名显示隐藏
                        position: 'right',
                        formatter: '{b}'
                    }
                },
                symbolSize: 2,
                // symbolSize: function (val) {
                //     return val[2] / 8;
                // },
                itemStyle: {
                    normal: {
                        color: '#009cff',
                        shadowBlur: 50,
                        shadowColor: '#333'
                    }
                },
                data: pointData.map(function (dataItem) {
                    return {
                        name: dataItem,
                        value: geoCoordMap[dataItem]
                    };
                })
            }
            ]
        };
        return option;
    }

    componentWillUnmount() {
        //一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
        window.removeEventListener('resize', this.handleResize, false);
    }

    handleResize = e => {
        this.state.myChart.setOption(this.getOption());
        this.state.myChart.resize();
    }


    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <div id='china_map' style={{ width: '100%', height: '100%' }}></div>
            </div>
        );
    }
}



export default ChartMapLine;